module.exports = __webpack_public_path__ + "img/logo2.c9e64c64.png";